export enum SubscriptionStatus {
    None,
    Active,
    Inactive
}